import { AttentionTypes } from '../../Definitions'
import { Pages } from '../../Navigation/root'
import { LangFile } from './'

const Texts: LangFile = {
  // #region | General
  additional: "附加",
  and: "和",
  change: "修改",
  choose: "选择",
  deleteFailed: "删除失败",
  editFailed: "编辑失败",
  filterBy: "筛选方式",
  from: "从",
  general: "通用",
  no: "否",
  noData: "无数据",
  noOptions: "无选项",
  of: "的",
  off: "关闭",
  on: "开启",
  optional: "可选",
  page: "页面",
  reset: "重置",
  required: "必填",
  saveAlert: "请保存或取消编辑视图",
  search: "搜索",
  select: "选择",
  success: "成功",
  to: "到",
  unknown: "未知",
  wasUpdated: "已更新",
  wasDeleted: "已删除",
  useSelectedTime: "使用所选时间",
  yes: "是",
  // #endregion

  // Regarding the language list:
  // Please translate only your own language. 
  // If your language is not on the list, then add it using a maximum of two 
  // initials followed by a colon and the language in quotation marks.
  languages: {
    en: "english",
    dk: "dansk",
    es: "español",
    de: "deutsch",
    ma: "普通话",
    ko: "한국어",
    nl: "nederlands",
  },

  cookie: {
    header: "Cookie",
    context1: "安睿浦 A/s 公司将 Cookie 用于以下用途：",
    context2: "点击“全部接受”即表示您同意我们使用 Cookie。否则系统将仅使用服务运行所必需的最少 Cookie，例如用于管理登录以及从 consys 平台获取数据。",
    purpose1: "支持网站功能，例如记住您的 Cookie 设置、偏好语言、货币等。",
    purpose2: "对您的网站使用情况进行统计分析，例如统计您查看和点击的内容类型。",
    accept: "接受必要 Cookie",
    acceptAll: "全部接受"
  },

  // #region | Units
  units: {
    animal: "动物",
    animals: "动物",
    units: "单位",
    capacity: "容量",
    cup: "杯",
    cups: "杯", 
    date: "日期",
    day: "天",
    days: "天",
    g: "克",
    hour: "小时",
    hourAgo: "小时前",
    hours: "小时",
    hoursAgo: "小时前",
    kg: "千克",
    minutAgo: "分钟前",
    minutesAgo: "分钟前",
    min: "分钟",
    milisec: "毫秒",
    pct: "百分比",
    sec: "秒",
    time: "时间",
    times: "次数",
    timeToday: "今日时间",
    timesToday: "今日次数",
    total: "总计",
    energy: "能量",
    gramPerMinute: "克/分钟",
    lenght: "长度"
  },
  // #endregion

  // #region | Buttons
  buttons: {
    add: "添加",
    apply: "应用",
    cancel: "取消",
    commit: "提交",
    confirm: "确认",
    create: "创建",
    csv: "CSV",
    deselectAll: "取消全选",
    details: "详情",
    edit: "编辑",
    excel: "Excel",
    filter: "筛选",
    goBack: "返回",
    menu: "菜单",
    move: "移动",
    next: "下一步",
    options: "选项",
    prev: "上一步",
    print: "打印",
    resetFilters: "重置筛选",
    save: "保存",
    selectAll: "全选",
    unit: "单位",
    close: "关闭",
  },
  // #endregion

  // #region | Menu Headers
  menuHeaders: {
    overview: "概览",
    globalMenu: "全局菜单",
    systemMenu: "系统菜单",
    attentions: "提醒",
    quickEntry: "快速录入",
    language: "语言",
    [Pages.dashboard]: "仪表板",
    [Pages.kpi]: "关键指标",
    [Pages.feedCurve]: "饲喂曲线",
    [Pages.feedCurves]: "饲喂曲线",
    [Pages.components]: "配料",
    [Pages.componentsAlternatives]: "替代配料",
    [Pages.mixtures]: "混合料",
    [Pages.silos]: "料仓",
    [Pages.silosSettings]: "料仓设置",
    [Pages.animal]: "动物",
    [Pages.animals]: "动物",
    [Pages.animalsGroups]: "动物群组",
    [Pages.reports]: "报表",
    [Pages.archive]: "归档",
    [Pages.logbook]: "日志",
    [Pages.globalSettings]: "设置",
    [Pages.devices]: "设备",
    [Pages.freeda_lf]: "概览",
    [Pages.freeda_lf_sections]: "区域",
    [Pages.freeda_lf_settings]: "设置",
    [Pages.op_operations]: "操作",
    [Pages.op_quickEntry]: "快速录入",
    [Pages.freeda_esf]: "概览",
    [Pages.freeda_esf_sections]: "区域",
    [Pages.freeda_esf_settings]: "设置"
  },
  // #endregion

  // #region | User
  user: {
    userInformation: "用户信息",
    user: "用户",
    userName: "用户名",
    firstName: "名",
    lastName: "姓",
    phone: "电话",
    email: "邮箱",
    password: "密码",
    repeatPassword: "确认密码",
    country: "国家",
    address: "地址"
  },
  // #endregion

  // #region | Farm
  farm: {
    farmInformation: "猪场信息",
    farmName: "猪场名称",
    city: "城市",
    street: "街道",
    phone: "电话",
    vat: "增值税号",
    email: "邮箱"
  },
  // #endregion

  // #region | Milestones
  milestones: {
    general: {
      milestone: "里程碑",
      milestones: "里程碑",
      noMilestoneFound: "未找到里程碑",
      animalsInMilestones: "里程碑中的动物",
      latestMilestone: "当前里程碑",
      milestoneDay: "当前里程碑天数",
      newMilestone: "新建里程碑"
    },
    defaultMilestones: {
      farrowing: "分娩",
      insemination: "配种",
      weaning: "断奶",
      movedToFarrowing: "转入分娩栏"
    }
  },
  // #endregion

  // #region | Events
  events: {
    events: "事件",
    eventType: "类型",
    eventDate: "日期",
    eventNote: "备注",
    eventTime: "时间",
    typeMissing: "缺少类型",
    dateMissing: "缺少日期",
    noteMissing: "缺少备注",
    addEvent: "添加事件",
    animal: "动物",
  },
  // #endregion

  // #region | Devices
  devices: {
    devices: "设备",
    name: "名称",
    cpuId: "CPU 编号",
    type: "类型",
    connection: "连接",
    system: "系统",
    noControllersFound: "未找到局域网控制器",
    lanControllers: "局域网控制器",
    newLcBoard: "新建 LC 板",
    boardName: "面板名称",
    boardNameMissing: "缺少面板名称",
    powerSupplyMissing: "缺少电源",
    maxAcPortsMissing: "缺少最大交流端口数",
    noIoBoards: "未找到 I/O 板",
    ioBoards: "I/O 板",
    newIoBoard: "新建 I/O 板",
    layout: "布局",
    horizontal: "水平",
    vertical: "垂直",
    asc: "升序",
    desc: "降序",
    columns: "列",
    rows: "行",
    order: "排序",
    direction: "方向",
    chooseIo: "选择 I/O",
    chooseRfidIo: "选择 RFID 阅读器 I/O",
    remainingInputs: "剩余输入",
    remainingOutputs: "剩余输出",
    aicoIo: "I/O 板",
    output: "输出",
    input: "输入",
    board: "面板",
    moveBoard: "移动面板",
    noTerminals: "无终端",
    terminalPort: "终端端口",
    pen: "栏位",
    ioSpecifications: "I/O 规格",
    numbering: "编号",
    manual: "手动",
    automatic: "自动",
    pattern: "模式",
    topLeft: "左上角",
    topRight: "右上角",
    bottomLeft: "左下角",
    bottomRight: "右下角",
    startCorner: "起始角",
    noLanController: "无局域网控制器",
    noCpuId: "无 CPU 编号",
    noSystem: "无系统",
    server: "服务器",
  },
  // #endregion

  // #region | System Controls
  systemControls: {
    general: {
      startSystem: "启动系统",
      systemControls: "系统控制",
      emergencyStop: "紧急停止",
      stopSystem: "停止系统",
      startAll: "全部启动",
      startSection: "启动分区",
      startSelected: "启动所选",
      calibrateSection: "校准分区",
      calibrateSelected: "校准所选",
      emptySection: "清空分区",
      emptySelected: "清空所选",
      clickPen: "点击选择要操作的栏位",
      clickStation: "点击您要选择的每个站点",
      unClickPen: "点击取消选择栏位",
      orSelectAll: "或全选",
      orDeselectAlle: "或取消全选",
      problem: "问题",
      problems: "问题",
      warning: "警告",
      warnings: "警告",
      attention: "提醒",
      attentions: "提醒",
      attentionType: "提醒类型",
      systemState: "系统状态",
      staticFeeding: "静态饲喂",
      nextFeeding: "下次饲喂",
      resolvedWeight: "已结算重量",
      noPensSelected: "未选择栏位",
      noStationsSelected: "No stations selected",
      feeding: "饲喂中",
      feedingFailed: "饲喂失败",
      calibrating: "校准中",
      calibratingFailed: "校准失败",
      changeTime: "修改时间",
      emptying: "清空中",
      emptyingFor: "清空对象",
      emptyingFailed: "清空失败",
      controls: "控制",
      confirmStop: "确定执行系统紧急停止？",
      goToSystem: "进入系统",
      systemStatus: "系统状态",
      date: "日期",
      level: "等级",
      type: "类型",
      inspect: "检查",
      delete: "删除",
      logid: "日志 ID",
      system: "系统",
      motor: "电机",
      animal: "动物",
      alerts: "警报",
      location_name: "区域名称",
      fk_lan_controllers: "局域网控制器关联",
      lan_controller_log_id: "局域网控制器日志 ID",
      attention_message: "提醒信息",
      attention_time: "提醒时间",
      runningWith: "运行配置",
      technicalData: "技术参数",
      startLocation: "起始位置", 
      calibrateLocation: "校准位置", 
      gateControl: "门控制", 
      autotuneAntenna: "自动调谐天线", 
      openGate: "开门",
      closeGate: "关门", 
      blockGate: "锁定门", 
      unblockGate: "解锁门", 
      autotuneSelected: "已选择自动调谐",
      autoTuneFailed: "自动调谐失败"
    },
    states: {
      [AttentionTypes.good]: "运行中",
      [AttentionTypes.neutral]: "已关闭",
      [AttentionTypes.warning]: "警告",
      [AttentionTypes.alert]: "警报"
    },
    createSystem: {
      createNewSystem: "新建系统",
      systemName: "系统名称",
      systemType: "系统类型",
      systemNameMissing: "缺少系统名称",
      systemTypeMissing: "缺少系统类型",
      systemLimitReached: "已达系统上限",
      createSystem: "创建系统"
    },
    blueprint: {
      blueprint: "设计图",
      upload: "上传",
      wrongType: "文件处理错误",
      wrongSize: "文件过大（最大 500KB）",
      pleaseDropImage: "请上传 JPEG 文件",
      pleaseSelectImage: "请选择 JPEG 文件",
      dropImage: "拖放设计图到此处",
      browseImage: "或从电脑选择",
      chooseFile: "选择文件",
      chooseAgain: "重新选择"
    }
  },
  // #endregion

  // #region | Motor Specs
  motorSpecs: {
    general: {
      skipCnt: "跳过次数",
      skipTime: "跳过时间",
      powerConsumption: "功耗",
      calibrationValue: "校准值",
      rotationTime: "转动时间",
      statusMode: "状态模式",
      noSkip: "无跳过",
      noPowerConsumption: "无功耗",
      noCalibrationValue: "无校准值",
      noRotationTime: "无转动时间",
      noStatusMode: "无状态模式",
      pending: "待处理",
      activated: "已激活",
      skippedUntil: "跳过至",
      noLiveData: "无实时数据"
    },
    terminalTypes: {
      input: "输入",
      output: "输出",
      buttonInput: "按钮输入",
      gateSensorInput: "门传感器输入",
      digitalInput: "数字输入",
      waterOutput: "供水输出",
      inputMotor: "电机输入",
      cupMotorOutput: "料杯电机输出",
      cupMotorInput: "料杯电机输入",
      gateMotorOutput: "门电机输出",
      gateMotorInput: "门电机输入",
      rfidReader: "RFID 阅读器",
      rfidReaderInput: "RFID 阅读器输入",
      rfidReaderDeviceId: "RFID 阅读器设备 ID",
      sensorP: "P 传感器",
      defaultMotor: "默认电机",
      locationFeeder: "区域饲喂器电机",
      activator: "触发器",
      water: "供水",
    },
    terminalProgrammed: {
      disabled: "已禁用",
      calibration: "校准",
      feedingOnFeedingTimes: "定时饲喂",
      motorPassive: "电机待机"
    }
  },
  // #endregion

  // #region | Params
  params: {
    animal: "动物",
    animalId: "动物编号",
    animal_number: "动物编号",
    location: "区域",
    location_id: "区域",
    feedCurve: "饲喂曲线",
    feedCurveId: "饲喂曲线",
    group: "群组",
    animal_group_id: "群组",
    condition: "体况",
    removeAnimals: "移动动物",
    resetTotalConsumed: "重置总消耗",
    manualFeedStart: "手动启动饲喂",
    clearCalendarEvents: "清空日历事件",
    insemination: "配种",
    weaning: "断奶",
    farrowing: "分娩",
    pregnancyCheck: "妊娠检查",
    birthDate: "出生日期",
    pregnant: "已妊娠",
    responderNo: "应答器编号",
    responderNumber: "应答器编号",
    lifeNo: "系谱号",
    life_number: "系谱号",
    animalType: "动物类型",
    milestone: "里程碑",
    milestone_id: "当前里程碑",
    milestone_day: "里程碑天数",
    system: "系统",
    system_id: "系统",
    excess_remaining: "缺少超过",
    animalRemainingToday: "今日剩余",
    animalRemainingYesterday: "昨日剩余",
    animalConsumedToday: "今日消耗",
    animalConsumedYesterday: "昨日消耗",
    animalMilestoneDay: "当前里程碑天数",
    animalCycleDayTotal: "总周期天数",
    section: "分区",
    reset_consumption: "重置消耗", 
  },
  negativeParams: {
    animal: "无动物",
    animals: "无动物",
    animalId: "无动物编号",
    location: "无位置",
    feedCurve: "无饲喂曲线",
    group: "无群组",
    condition: "无状态",
    component: "无配料",
    birthDate: "无出生日期",
    pregnant: "未妊娠",
    responderNo: "无应答器编号",
    lifeNo: "无系谱号",
    animalType: "无动物类型",
    milestone: "无里程碑",
    system: "无系统",
    ds: "无干物质",
    energy: "无能量",
    limit: "无限制",
    gramPerMinute: "无克/分钟",
    priority: "无优先级",
    protein: "无蛋白质",
  },
  // #endregion

  // #region | Configs
  configs: {
    stationStatus: {
      creation: "创建中",
      init: "初始化",
      termCheck: "终端检查",
      calibrate: "校准",
      idle: "空闲",
      waitingTag: "等待标签",
      fetchFeeding: "获取饲喂数据",
      oneFeeding: "单次饲喂",
      spray: "喷墨",
      feeding: "饲喂中",
      waitingLeave: "等待离开",
      blocked: "已锁定",
      disabled: "已禁用",
      error: "错误",
      end: "结束"
    },
    feedMotor: {
      init: "Initilazing",
      idle: "Idle",
      running: "Running",
      bookCal: "Book Calibrate",
      bookEmpty: "Book Empty",
      starting: "Starting",
      cal: "Calibrate",
      empty: "Empty",
      end: "End",
      retry: "Retry",
      safetyOne: "Safety 1",
      safetyTwo: "Safety 2",
      safetyThree: "Safety 3",
      error: "Error"
    },
    gateMotor: {
      unknown: "Unknown",
      noGate: "No Gate",
      gateClosed: "Gate closed",
      gateClosing: "Gate closing",
      gateOpen: "Gate open",
      gateOpening: "Gate opening"
    }
  },
  // #endregion

  // #region | Feed
  feed: {
    general: {
      feed: "饲料",
      feeding: "饲喂",
      remainingToday: "今日剩余",
      remainingYesterday: "昨日剩余",
      waterUseToday: "今日用水",
      notFed: "近两天采食<20%",
      feedLastDays: "近10天",
      currentProgress: "当前进度",
      fedLastPeriod: "上期饲喂量",
      fedTotal: "总饲喂量",
      feedConsumption: "饲料消耗",
      feedBalance: "饲料结余",
      consumedToday: "今日消耗",
      consumedYesterday: "昨日消耗",
      expectedConsumption: "预计消耗",
      actualConsumption: "实际消耗"
    },
    feedCurve: {
      feedCurve: "饲喂曲线",
      active: "启用",
      noFeedCurve: "未找到饲喂曲线",
      default: "默认",
      minFeedSpeed: "最低饲喂速度（克/分钟）",
      maxFeedSpeed: "最高饲喂速度（克/分钟）",
      feedSpeed: "饲喂速度",
    },
    feedCorrection: {
      increased: "已增加",
      decreased: "已减少",
      disabled: "已禁用",
      feedCorrection: "饲喂校正",
      feedCorrections: "饲喂校正"
    },
    feedSkip: {
      feedSkip: "跳过饲喂",
      skipFeeding: "跳过饲喂",
      noSkip: "不跳过",
      skipForNow: "立即跳过",
      planSkip: "计划跳过",
      planFeedSkip: "计划跳过饲喂",
      standardSkip: "标准跳过",
      startFeeding: "开始饲喂",
      invalidDay: "无效日期",
      invalidTime: "无效时间",
      endDateBeforeStartDate: "结束日期早于开始日期",
      endTimeBeforeStartTime: "结束时间早于开始时间",
      timeSpan: "时间段",
      timeAmount: "时长",
      startDate: "开始日期",
      endDate: "结束日期",
      startTime: "开始时间",
      endTime: "结束时间",
      plannedSkip: "已计划跳过",
      recentFeedSkipSuccess: "最近跳过状态"
    }
  },
  // #endregion

  // #region | Login Flow
  loginFlow: {
    def: {
      fullView: "完整视图",
      focus_view: "聚焦视图",
      goToSiteList: "进入站点列表",
      switchTofocus_view: "切换到聚焦视图",
      switchToFullView: "切换到完整视图"
    },
    login: {
      login: "登录",
      logOut: "退出登录",
      welcomeBack: "欢迎回来",
      notRegisteredYet: "尚未注册",
      createNewuser: "创建新用户",
      forgotPassword: "忘记密码",
      resetPassword: "重置密码",
      missingUserName: "缺少用户名",
      missingPassword: "缺少密码",
      couldNotLogin: "登录失败",
      noSitesFound: "未找到站点"
    },
    forgotPassword: {
      forgotPassword: "忘记密码",
      resetPassword: "重置密码",
      text: "若用户名未绑定邮箱，请联系支持获取帮助。",
      text2: "重置完成前请勿关闭窗口。",
      noEmail: "未绑定邮箱",
      contactSupport: "联系支持",
      usernameRequired: "请输入用户名",
      noUsernameFound: "用户名不存在"
    },
    resetPassword: {
      resetPassword: "重置密码",
      text: "临时验证码已发送至邮箱，请输入以设置新密码。",
      temporaryCode: "临时验证码",
      newPassword: "新密码",
      repeatPassword: "确认新密码",
      createNewPassword: "设置新密码",
      contactSupport: "联系支持",
      noPasswordRevieved: "未收到验证码",
      newPasswordFail: "新密码设置失败"
    },
    createUser: {
      newUser: "新用户",
      missingUserName: "缺少用户名",
      missingPassword: "缺少密码",
      missingRepeatPassword: "请确认密码",
      passwordMismatch: "密码不一致",
      success: "成功"
    },
    chooseSite: {
      chooseSite: "选择站点",
      siteName: "站点名称",
      domain: "域名",
      id: "ID",
      tools: "工具"
    }
  },
  // #endregion

  // #region | Widgets
  widgets: {
    general: {
      noWidgets: "本页暂无组件",
      widgetOptions: "组件选项",
      manageWidgets: "管理",
      name: "名称",
      type: "类型",
      widgetPriority: "优先级",
      createNew: "新建",
      copyExisting: "复制已有"
    },
    widgetTypes: {
      autoReports: "自动报表",
      autoReportsAndMore: "自动报表等",
      graph: "图表",
      progress: "进度环"
    },
    graph: {
      noGraphSelected: "未选择图表",
      graphIncludesStart: "图表包含所有动物",
      graphIncludesEnd: "饲料消耗数据的动物",
      animalsToInclude: "按系统筛选动物",
      last10Days: "Last 10 days feed consumption",
      last10DaysComponent: "近10天饲料成分消耗",
     },
    autoReports: {
      autoReports: "自动报表",
      navigatedFromSystem: "从系统跳转",
      add: "添加自动报表",
      addExisting: "添加已有"
    }
  },
  // #endregion

  // #region | Penlist
  penList: {
    basicDisclaimer: "鼠标悬停查看列类型",
    editDisclaimer: "选择新数值编辑动物",
    addDisclaimer: "下拉添加动物，点垃圾桶移除",
    moveDisclaimer: "下拉移动动物，点垃圾桶移除"
  },
  // #endregion

  // #region | Feed Curve pages
  feedCurvePages: {
    feedCurves: {
      copyFeedCurve: "复制饲喂曲线",
      createFeedCurve: "创建饲喂曲线",
      createFeedCurveFromScratch: "新建饲喂曲线",
      feedCurveDetails: "饲喂曲线详情",
      newFeedCurve: "新建饲喂曲线",
      feedCurveName: "饲喂曲线名称",
      fromFeedCurve: "源自饲喂曲线",
      feedCurveNameMissing: "缺少饲喂曲线名称",
      goToFeedCurvePage: "进入饲喂曲线页面"
    },
    components: {
      components: "配料",
      emptyText: "未找到配料",
      name: "配料名称",
      readyMixture: "即用混合料",
      priority: "优先级",
      ds: "干物质",
      energy: "能量",
      protein: "蛋白质",
      gramPerMinute: "克/分钟",
      limit: "限制",
      newComponent: "新建配料"
    },
    feedCurve: {
      spreading: "分配饲喂",
      spreadings: "分配饲喂",
      noSpreading: "无分配饲喂",
      settings: "设置",
      day: "天",
      watchFeedCurve: "查看饲喂曲线",
      doNotPassFeed: "不跳过饲喂",
      passFeed: "跳过饲喂",
      stimuli: "刺激饲喂",
      noStimuli: "无刺激饲喂",
      addStimuli: "添加刺激饲喂",
      singleStimuli: "单次刺激",
      repeatStimuli: "重复刺激",
      maxAmount: "周期最大量（千克）",
      remainingFeed: "剩余饲料",
      maxFeedToPass: "最大递料量（千克）",
      max: "最大",
      feeding: "饲喂",
      feedings: "饲喂次数",
      feedStimuli: "饲喂刺激",
      minutesApart: "间隔分钟",
      addTime: "添加时间",
      saveChanges: "保存修改",
      resetChanges: "重置修改",
      feedCurveLenght: "时长",
      feedLimit: "饲喂限制",
      animalCount: "动物数量",
      consumedToday: "今日消耗",
      usage: "当前用量",
      unknownMilestoneAndDay: "未知里程碑与天数",
      deleteFeedcurve: "删除饲喂曲线",
      confirmDelete: "确定删除此饲喂曲线？",
      noFeedcurves: "未找到饲喂曲线"
    }
  },
  // #endregion

  // #region | Animal pages
  animalPages: {
    animals: {
      animals: "动物",
      emptyText: "未找到动物",
      quickEntry: "快速录入",
      newAnimal: "新建动物",
      viewChanges: "查看修改",
      action: "操作",
      selectAnimals: "选择动物",
      missingAnimalNo: "缺少动物编号",
      missingResponderNo: "缺少应答器编号",
      kgFedMore: "饲喂超量",
      noAnimalsMatchTheSelection: "无匹配动物",
      responderLengt: "应答器编号必须15位",
      lifeNoLengt: "系谱号不超过9位",
      columns: "列",
      priority: "优先级",
      tablePreferences: "表格偏好",
      resetConsumptionDisclaimer: "注意：重置消耗仅适用于 ESF",
    },
    animalGroups: {
      group: "群组",
      numberOfAnimals: "动物数量",
      createGroup: "创建群组",
      newGroup: "新建群组",
      groupName: "群组名称"
    },
    animal: {
      animal: "动物",
      basicInfo: "基本信息",
      noAnimalSelected: "未选择动物",
      noAnimalsSelected: "未选择任何动物",
      addAnimal: "添加动物",
      addAnimalToPen: "添加动物到栏位",
      pen: "栏位",
      moveAnimal: "移动动物",
      moveAnimals: "移动动物",
      moveAnimalFromPen: "移至栏位",
      goToAnimal: "进入动物页",
      totalCycleDay: "总周期天数",
      marking: "标记",
      noTimeline: "无时间线",
      timeline: "时间线",
      viewTimeline: "查看时间线",
      born: "出生日期",
      timelineShows: "时间线显示胎次",
      parity: "胎次",
      deleteAnimal: "删除动物",
      deleteConfirm: "确定删除此动物？"
    }
  },
  // #endregion

  // #region | Report pages
  reportPages: {
    reports: {
      template: "模板",
      templateName: "模板名称",
      addTemplate: "添加模板",
      copyTemplate: "复制模板",
      createReport: "创建报表",
      createNewReport: "新建空白报表",
      newTemplate: "新建模板",
      newReport: "新建报表",
      dataLevel: "数据层级",
      filterParameter: "筛选参数",
      dataParameter: "数据参数",
      reportName: "报表名称",
      archiveReport: "归档报表",
      startDate: "开始日期",
      endDate: "结束日期",
      showInReport: "报表中显示",
      fromTemplate: "源自模板",
      noReportFound: "未找到报表",
      noDataParameterFound: "未找到数据参数",
      unknownCondition: "未知状态",
      unknownAnimalGroup: "未知群组",
      noFilterParameterFound: "未找到筛选参数",
      saveAsTemplate: "另存为模板"
    },
    manageTemplates: {
      templateOptions: "模板选项",
      manageTemplates: "管理",
      copyExisting: "复制已有",
      noTemplates: "本页暂无模板"
    },
    report: {
      report: "报表",
      editReport: "编辑报表",
      unArchiveReport: "取消归档",
      saveAsTemplate: "另存为模板",
      noReport: "未找到报表",
      noReports: "未找到报表",
      deleteReport: "删除报表",
      deleteConfirm: "确定删除此报表？"
    },
    reportColumn: {
      system: "系统",
      system_id: "系统",
      animal_id: "动物",
      animal_button: "动物",
      location: "区域",
      location_id: "区域",
      section_id: "分区",
      section: "分区",
      feedcurve_id: "饲喂曲线",
      feedCurveId: "饲喂曲线",
      animal_number: "动物编号",
      cycle: "周期",
      correction: "校正",
      feedcurve_milestones: "饲喂曲线里程碑",
      milestone_day: "里程碑天数",
      condition: "状态",
      animal_type: "动物类型",
      responder_number: "应答器编号",
      life_number: "系谱号",
      birthday: "出生日期",
      animal_group_name: "群组",
      milestone_name: "里程碑",
      milestone_id: "里程碑",
      animal_group_id: "群组",
      group_id: "群组",
      group_name: "群组名称",
      system_id_for_report: "报表用系统ID",
      system_name: "系统",
      totalPeriodConsumption: "周期总消耗",
      consumed: "消耗量"
    },
    archive: {
      archive: "归档",
      filterByNumber: "按报表编号筛选",
      filterByName: "按名称筛选",
      archivedReport: "已归档报表",
      noStartDateFound: "无开始日期",
      noEndDateFound: "无结束日期"
    },
    errorMessages: {
      missingName: "缺少名称",
      missingStartDate: "缺少开始日期",
      missingEndDate: "缺少结束日期",
      missingDataLevel: "缺少数据层级",
      missingFilterParameters: "缺少筛选参数"
    }
  },
  // #endregion

  // #region | Logbook pages
  logPages: {
    logbook: {
      problem: "问题",
      warning: "警告",
      info: "信息",
      debug: "调试",
      system: "系统",
      motor: "电机",
      animal: "动物",
      time: "时间",
      level: "等级",
      type: "类型",
      message: "信息",
      location: "区域",
      controller: "控制器",
      allControllers: "所有控制器",
      controllerName: "控制器名称",
      deviceName: "设备名称",
      lanControllers: "局域网控制器",
      getLog: "获取日志",
      noLogsAvailable: "未找到日志",
      responder: "应答器"
    }
  },
  // #endregion

  // #region | Global Settings pages
  globalSettingsPages: {
    globalSettings: {
      imperial: "英制",
      metric: "公制",
      saveChanges: "保存修改",
      discardChanges: "放弃修改",
      userManagement: "用户管理",
      workerManagement: "员工管理",
      timeZone: "时区",
      feedDayStart: "饲喂日起始",
      remove: "移除",
      emailAttentionDisclaimerWorker: "选择员工接收提醒的系统",
      emailAttentionDisclaimerUser: "选择您接收提醒的系统",
      settingsFor: "设置对象",
      systemNotifications: "系统通知"
    }
  },
  // #endregion

  // #region | Location Feeder Pages
  locationFeederPages: {
    locationFeeder: {
      sections: "分区",
      pens: "栏位",
      animals: "动物",
      sectionNo: "分区编号",
      pen: "栏位"
    },
    sections: {
      section: "分区",
      sections: "分区",
      map: "地图",
      animalAmount: "动物数量",
      penValueHeaders: "悬停查看列类型",
      sectionNotFound: "未找到分区",
      emptyPen: "空栏位",
      feeder: "饲喂器",
      inThisPen: "本栏内",
      activations: "激活次数",
      lastActivated: "上次激活",
      newSection: "新建分区",
      sectionName: "分区名称",
      firstPenNo: "起始栏位号",
      penAmount: "栏位数量",
      clickOnPen: "点击添加/移除栏位",
      penContent: "栏位内容",
      feederOnly: "仅饲喂器",
      water: "供水",
      activator: "触发器",
      feederOutput: "饲喂器输出",
      waterOutput: "供水输出",
      activatorInput: "触发器输入",
      since: "起始时间",
      redirect: "即将跳转到动物页",
      expand: "展开",
      collapse: "收起",
      noSections: "未找到分区",
      noAnimal: "无动物",
      editSection: "编辑分区",
      clickPen: "点击选择要编辑的栏位",
      clicStation: "点击您要编辑的每个站点",
      deleteSectionConfirm: "确定删除此分区？",
      priority: "优先级",
      sectionNameMissing: "缺少分区名称",
      pen: "栏位",
    },
    settings: {
      dailyRotation: "每日转动",
      dailyRotationDisclaimer: "注意：位置为空或无饲喂曲线时，电机将每日维护转动。",
      feedInSilos: "料仓饲料量",
      attentionLimit: "提醒阈值",
      feedAmount: "饲喂量",
      defFeedAmount: "默认饲喂量（克）",
      deleteSystem: "删除系统",
      deleteDisclaimer: "确定删除此系统？",
      systemName: "系统名称"
    }
  },
  // #endregion

  // #region | ESF Walk Through Pages
  esfWalkThroughPages: {
    esfWalkThrough: {
      pens: "栏位", 
      station: "站点",
      stations: "站点", 
      animals: "动物", 
      motor: "电机",
      component: "成分", 
      noComponent: "无成分", 
      include: "包含",
    },
    sections: {
      pen: "栏位",
      pens: "栏位", 
      station: "站点",
      stationFeeding: "饲喂", 
      feedMotor: "饲料电机",
      feedSensor: "饲料传感器",
      gateMotor: "门电机",
      gateSensor: "门传感器",
      inThisStation: "在此站点",
      previously: "之前",
      feedComponents: "饲料成分",
      stationLastDays: "近10天",
      stationLog: "日志",
      noPens: "未找到栏位", 
      currentlyInThisPen: "当前在此栏位",
      animal: "动物",
      noAnimal: "无动物",
      unknownAnimal: "未知动物",
      fedToday: "今日饲喂", 
      usesToday: "今日使用",
      stationsState: "站点状态", 
      available: "可用",
      consumed: "已消耗", 
      number: "编号",
      water: "水", 
      waterAddedPrCup: "每杯加水量", 
      waterDelay: "水延迟", 
      gateAdjustment: "门调节",
      delayTimeClosingGate: "关门延迟时间", 
      indetificationValidTime: "识别有效时间",
      entryTime: "进入时间", 
      feedMotors: "饲料电机",
      noFeedBlockTime: "无饲料阻塞时间", 
      lastFeedBlockTime: "上次饲料阻塞时间",
      motorComponents: "电机组件",
      motor: "电机",
      missing: "缺失",
    },
    newSection: {
      firstStationNo: "起始工位号",
      firstColumnExit: "第一列出口",
      secondColumnExit: "第二列出口",
      numberOfFeeders: "饲喂器数量",
      water: "供水",
      button: "按钮",
      waterOutput: "供水输出",
      buttonInput: "按钮输入",
      feederOutput: "饲喂器输出",
      feederInput: "饲喂器输入",
      gateMotorOutput: "门电机输出",
      gateMotorInput: "门电机输入",
      gateSensor: "门传感器",
      newPen: "新建栏位",
      penName: "栏位名称",
      numberOfStations: "工位数量",
      clickOnStation: "点击添加/移除工位",
      stationContent: "工位内容",
      editPen: "编辑栏位",
      clickStationToEdit: "点击选择要编辑的工位",
      station: "工位",
      penNameMissing: "缺少栏位名称",
      editFailed: "编辑失败",
      noStationsSelected: "未选择工位",
      deletePenConfirm: "确定删除此栏位？"
    },
    settings: {
    },
    systemControl: {

    }
  },
  // #endregion

  // #region | Focus View Pages
  focus_viewPages: {
    location: "区域",
    system: "系统",
    section: "分区",
    inThisPen: "本栏内",
    today: "今日",
    pen: "栏位",
    since: "起始时间",
    day: "天",
    moveAnimal: "移动动物",
    newLocation: "新区域",
    emptyPen: "空栏位"
  }
  // #endregion
}
export default Texts